import { useEffect } from "react";
import type { ReactNode } from "react";
import { haptic } from "../lib/tg";

/**
 * Нижняя шторка — нативный для Telegram способ показать второстепенный экран:
 * контент остаётся на месте, шторка приезжает снизу и закрывается тапом по фону.
 *
 * Раньше такие блоки (фильтры каталога) раскрывались прямо в потоке страницы и
 * уезжали вместе со скроллом: список под ними прыгал, а до кнопки «применить»
 * приходилось листать. Шторка держит их в одном месте поверх содержимого.
 */
export default function Sheet({
  open,
  title,
  onClose,
  children,
}: {
  open: boolean;
  title?: string;
  onClose: () => void;
  children: ReactNode;
}) {
  // Пока шторка открыта, страница под ней не скроллится: иначе тап по фону
  // легко превращается в прокрутку каталога, и шторка «залипает».
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  if (!open) return null;

  const close = () => { haptic.tap(); onClose(); };

  return (
    <div className="sheet" onClick={close}>
      <div className="sheet__panel" onClick={(e) => e.stopPropagation()}>
        <div className="sheet__grip" />
        {title && (
          <div className="sheet__head">
            <p className="section-label" style={{ margin: 0 }}>{title}</p>
            <button className="sheet__close" onClick={close} aria-label="Закрыть">×</button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
